import script from "./leadContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./leadContent.vue?vue&type=script&lang=ts&setup=true"

import "./leadContent.vue?vue&type=style&index=0&id=6ffb82ee&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ffb82ee"]])

export default __exports__